export interface Project {
  readonly id: string;
  readonly colorPalette?: string;
  readonly name: string;
  /** Civil date in `dd.MM.yyyy`. */
  readonly start: string;
  /** Civil date in `dd.MM.yyyy`, or empty when open-ended. */
  readonly end: string;
  readonly createdBy: string;
  readonly createdAt: string;
  readonly editedBy: string;
  readonly editedAt: string | null;
}

/** Sentinel: workspace-default / no named project. Always first in the selector. */
export const NO_PROJECT_ID = '';

export const NO_PROJECT: Project = {
  id: NO_PROJECT_ID,
  name: '',
  start: '',
  end: '',
  createdBy: '',
  createdAt: '',
  editedBy: '',
  editedAt: null,
};

/** Create / update body — display dates (`dd.MM.yyyy`), empty end = open-ended. */
export interface ProjectInput {
  readonly colorPalette?: string;
  readonly name: string;
  readonly start: string;
  readonly end: string;
}
